import get from 'lodash/fp/get'
import pipe from 'lodash/fp/pipe'
import { PRED_TECH_LOG_TYPES, PRED_TECH_ESTIMATION_TYPES } from '../constants'
const { SAC_HA, PROD_HA, NITRO, TCH_PRED, POL_PRED } = PRED_TECH_LOG_TYPES
const {
  HEMAV_PRODPH_ESTIMATION,
  HEMAV_ATR_ESTIMATION,
  HEMAV_POL_ESTIMATION,
  HEMAV_SAC_ESTIMATION,
  HEMAV_N_BUNCHES_ESTIMATION,
  HEMAV_NITROGEN_ESTIMATION
} = PRED_TECH_ESTIMATION_TYPES

export const getPredTechLogs = get('predTech')

export const getLogsByType = logType => pipe(getPredTechLogs, get(logType))

export const getSacHa = getLogsByType(SAC_HA)

export const getProdHa = getLogsByType(PROD_HA)

export const getNitro = getLogsByType(NITRO)

export const getTchPred = getLogsByType(TCH_PRED)

export const getPolPred = getLogsByType(POL_PRED)

export const getIdealParameters = pipe(getPredTechLogs, get('idealParameters'))

export const getProdphEstimation = getLogsByType(HEMAV_PRODPH_ESTIMATION)

export const getAtrEstimation = getLogsByType(HEMAV_ATR_ESTIMATION)

export const getPolEstimation = getLogsByType(HEMAV_POL_ESTIMATION)

export const getSacEstimation = getLogsByType(HEMAV_SAC_ESTIMATION)

export const getNBunchesEstimation = getLogsByType(HEMAV_N_BUNCHES_ESTIMATION)

export const getNitrogenEstimation = getLogsByType(HEMAV_NITROGEN_ESTIMATION)
